import type { MeasurementSystem } from "@bw/shared/api";
export type { MeasurementSystem } from "@bw/shared/api";

const KM_PER_MILE = 1.609344;
const PRESETS = [5, 10, 25, 50, 100];
const inDisplayUnits = (km: number, system: MeasurementSystem) => system === "metric" ? km : km / KM_PER_MILE;
const unit = (system: MeasurementSystem) => system === "metric" ? "km" : "mi";

export function formatDistance(km: number | string | null | undefined, system: MeasurementSystem, suffix = ""): string | null {
  if (km == null || (typeof km === "string" && !km.trim()) || !Number.isFinite(Number(km)) || Number(km) < 0) return null;
  return `${inDisplayUnits(Number(km), system).toFixed(1)} ${unit(system)}${suffix}`;
}

export function readRadiusKm(value: string | null, system: MeasurementSystem): number {
  const parsed = Number(value);
  return value?.trim() && Number.isFinite(parsed) && parsed >= 1 && parsed <= 500
    ? parsed : system === "metric" ? 50 : 40.2336;
}

export function radiusLabel(km: number, system: MeasurementSystem): string {
  return `${Number(inDisplayUnits(km, system).toFixed(1))} ${unit(system)}`;
}

export function distanceOptions(currentKm: number, system: MeasurementSystem) {
  const choices = PRESETS.map(value => ({
    value: Number((system === "metric" ? value : value * KM_PER_MILE).toFixed(8)),
    label: `${value} ${unit(system)}`,
  }));
  if (!choices.some(choice => Math.abs(choice.value - currentKm) < 0.0000001)) {
    choices.unshift({ value: currentKm, label: radiusLabel(currentKm, system) });
  }
  return choices;
}
